var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"group inline-flex w-[88px] justify-center border border-global-secondary bg-global-secondary p-3 transition duration-300 hover:border-global-tertiary hover:bg-global-tertiary",on:{"click":function($event){return _vm.$emit('click')}}},[_c('UIIcon',{staticClass:"h-6 w-6 text-global-white",attrs:{"name":"play-icon"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }